// extracted by mini-css-extract-plugin
module.exports = {"item":"K_cQ","item__image":"K_cR","item__title":"K_cS","item__counter":"K_cT","item__active":"K_cV"};